import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

declare global {
    interface Window {
        loadedWxSdk: any;
    }
}

export enum WechatHelperEventsKeys {
    WINDOW_LOADED = 'windowLoaded',
    READY = 'ready',
}

export interface WechatHelperEventsMap {
    [WechatHelperEventsKeys.WINDOW_LOADED]: void;
    [WechatHelperEventsKeys.READY]: void;
}

export class WechatHelper {
    public static instance;
    public static getInstance() {
        if (!WechatHelper.instance) {
            WechatHelper.instance = new WechatHelper();
        }
        return WechatHelper.instance;
    }

    public installed = false;
    private event;
    private windowLoaded = false;

    public constructor() {
        this.event = new EventBus<WechatHelperEventsMap>();
        const cb = () => {
            this.windowLoaded = true;
            this.event.emit(WechatHelperEventsKeys.WINDOW_LOADED);
            window.removeEventListener('load', cb);
        };
        window.addEventListener('load', cb);
    }

    public install(callback?: () => void) {
        if (this.installed) {
            return;
        }
        this.installed = true;
        checkIfLoadJsSdk(() => {
            this.event.emit(WechatHelperEventsKeys.READY);
            const p1 = new Promise<void>((resolve) => {
                if (!window.WeixinJSBridge?.invoke) {
                    document.addEventListener(
                        'WeixinJSBridgeReady',
                        () => {
                            resolve();
                        },
                        false,
                    );
                } else {
                    resolve();
                }
            });
            p1.then(callback);
        });
    }

    public onReady(callback) {
        if (window.wx) {
            callback?.();
        } else {
            const off = this.event.on(WechatHelperEventsKeys.READY, () => {
                callback?.();
                off();
            });
        }
    }

    public onLoadFinish(callback: () => void) {
        if (window.wx && this.windowLoaded) {
            callback?.();
        } else {
            const p1 = new Promise<void>((resolve) => {
                this.onReady(() => {
                    resolve();
                });
            });

            const p2 = new Promise<void>((resolve) => {
                if (this.windowLoaded) {
                    resolve();
                } else {
                    const off = this.event.on(WechatHelperEventsKeys.WINDOW_LOADED, () => {
                        resolve();
                        off();
                    });
                }
            });

            Promise.all([p1, p2]).then(() => {
                callback?.();
            });
        }
    }
}

export function checkIfLoadJsSdk(cbSuc = () => {}, cbFail = () => {}) {
    // 普通微信(双平台)和安卓端企业微信才需要加载jweixin-1.6.0.js
    const isWXOrAndroidwxWork = browser.isWeChat || browser.isWxMiniProgram || (browser.isAndroid && browser.isWxWork);
    if (browser.isQQ || isWXOrAndroidwxWork) {
        if (!window.wx || !window.loadedWxSdk) {
            const script = document.createElement('script');
            script.src = isWXOrAndroidwxWork ? RUNTIME.LIBRARY.WX_JS_SDK_1_6_0 : RUNTIME.LIBRARY.QQ_JS_SDK_1_0_0;
            script.onload = cbSuc;
            script.id = isWXOrAndroidwxWork ? 'jwxsdk' : 'jqqsdk';
            document.head.appendChild(script);
            window.loadedWxSdk = true;
        } else {
            cbSuc();
        }
    } else {
        cbFail();
        return;
    }
}
